

































































































import { Component, Vue } from 'vue-property-decorator'
import { setToken, setSchoolInfo, setRoleType, setLocale, getLocale } from '@/utils/utils'
import { LoginController, TraceController } from '@/services/request.service'
import { ssoUtils } from 'sso-utils'
const Logo = require('@/assets/images/logo.svg')

@Component
export default class Login extends Vue {
  private accountLoginForm: any
  private loginLoading = false
  private schoolVisible = false
  private schoolList: any = []
  private selectedSchoolId: any = 0
  private locale = 'en'

  private get logo(): any {
    return this.$store.state.logo || Logo
  }

  private beforeCreate(): void {
    this.accountLoginForm = this.$form.createForm(this)
  }

  private created(): void {
    this.locale = getLocale()
  }

  private changeLocale(): void {
    const currentLocale = this.$i18n.locale
    const language = currentLocale === 'zh' ? 'en' : 'zh'
    this.$i18n.locale = language
    this.$store.commit('changeLocale', language)
    setLocale(language)
    this.locale = language
  }

  private accountSubmit(e: Event): void {
    this.loginLoading = true
    e.preventDefault()
    this.accountLoginForm.validateFields({ first: true }, (err: any, values: any) => {
      if (!err) {
        const mobile = this.accountLoginForm.getFieldValue('mobile')
        const password = this.accountLoginForm.getFieldValue('password')
        const autoLogin = this.accountLoginForm.getFieldValue('remember')
        LoginController.login({ mobile, password, autoLogin })
          .then(res => {
            const token = res.data.token
            const schools = res.data.schools
            setToken(token, autoLogin)
            setSchoolInfo(schools[0])
            setRoleType(res.data.roleType)
            location.reload()
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            this.loginLoading = false
          })
      } else {
        this.loginLoading = false
      }
    })
  }
}
